import React, { ChangeEvent } from 'react';

import TextInput from 'DesignLibrary/atoms/inputs/TextInput';

export interface DateOfBirthInputProps {
  stretch: boolean;
  value?: string;
  onChange: (dob: string) => void;
  error: boolean;
}

const formatDob = (raw: string) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  const parts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean);
  return parts.join('/');
};

export const isValidDob = (value: string) => {
  // Ensure the input matches the expected MM/DD/YYYY format
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false;

  const [mm, dd, yyyy] = value.split('/').map(Number);

  // Date months are zero-based, so subtract 1 from the input month
  const date = new Date(yyyy, mm - 1, dd);

  // Verify that the Date object represents the same day, month, and year as input
  // Add 1 to date.getMonth() because getMonth() is zero-based
  if (date.getFullYear() !== yyyy || date.getMonth() + 1 !== mm || date.getDate() !== dd) {
    return false;
  }

  // Valid if age is between 0 and 120 years
  const age = new Date().getFullYear() - yyyy;
  const valid = age >= 0 && age <= 120;

  return valid;
};

export const DateOfBirthInput = ({ stretch, value = '', onChange, error = false }: DateOfBirthInputProps) => {
  const handleChange = (_: ChangeEvent<HTMLInputElement>, raw?: number | string | null) => {
    const text = raw?.toString() ?? '';
    onChange(formatDob(text));
  };

  return (
    <TextInput
      data-testid="dob-input"
      stretch={stretch}
      inputType="normal"
      inputMode="numeric"
      placeholder="MM/DD/YYYY"
      value={value}
      handleChange={handleChange}
      error={error}
    />
  );
};
